import { Redirect, useParams } from 'react-router';
import { CommunicationNotePage } from './communication-note';
import { ROUTING_CONFIG } from '@uplift/constants';
import { MedicalNoteType } from '@uplift/api';
import { DischargeNotePage } from './discharge-note';
import { ClaimCorrectionsPage } from '../claim-corrections-page/ClaimCorrections.page';

export type RouteParams = {
  noteType: MedicalNoteType;
  noteId: string;
  patientId: string;
};

export const NotesPage: React.VFC = () => {
  const { noteType, noteId, patientId } = useParams<RouteParams>();

  switch (noteType) {
    case MedicalNoteType.communicationNote:
      return <CommunicationNotePage noteId={noteId} patientId={patientId} />;
    case MedicalNoteType.therapyDischargeNote:
    case MedicalNoteType.psychiatryDischargeNote:
      return <DischargeNotePage noteId={noteId} patientId={patientId} />;
    case MedicalNoteType.claimCorrectionNote:
      return <ClaimCorrectionsPage noteId={noteId} patientId={patientId} />;
    default:
      return <Redirect to={ROUTING_CONFIG.main} />;
  }
};
